<template>
  <div id="m-detail">
    <div class="m-d-box">
      <MHead ref="mhead" v-if="showHead" @slideto="slideChangeFn"></MHead>
      <div class="m_banner" v-if="showHead" @click="closeList"></div>
      <div class="m-detail-content" @click="closeList">
        <div v-if="!faq" class="m-news-detail">
          <div class="m-news-content-title">{{title}}</div>
          <div class="m-news-content-date">{{date}}</div>
          <pre v-html="content" class="m-detail-cont"></pre>
        </div>
        <div v-else class="m-faq-list-box">
          <div class="m-faq-item" v-for="(item, index) in _myData.faqs" :key="index">
            <div class="m-faq-title">
              <div class="m-faq-index">Q{{index + 1}}</div>
              <div class="m-faq-label">{{item.title}}</div>
            </div>
            <div class="m-faq-des">{{item.content}}</div>
          </div>
        </div>
      </div>
      <MBottom v-if="false"></MBottom>
    </div>
  </div>
</template>

<script>
import MHead from "@/components/mobile/m-head";
import MBottom from "@/components/mobile/m-bottom";
import { newsDetail } from "@/proxy/index"
import { mapState } from "vuex";
export default {
  components: {
    MHead,
    MBottom,
  },
  data() {
    return {
      content: "",
      date: '',
      title: '',
      faq: false,
      showHead: true,
    };
  },
  computed: {
    ...mapState(["_myData"])
  },
  created () {
    // window.scrollTo({
    //   top: 0,
    // });
    if (this.$route.query.id == 'faq') {
      this.faq = true
    } else {
      newsDetail(this.$route.query.id).then(res => {
        if (res.data.code == 0) {
          const data = res.data.data
          this.title = data.title
          this.date = data.publish_time
          this.content = data.content
        }
      })
    }

  },
  mounted () {
    if ( this.$route.query.isns && this.$route.query.isns == 'y' || sessionStorage.getItem('showHead') ) {
      this.showHead = false
      sessionStorage.setItem('showHead', 'false')
      document.body.style.background = '#263176'
      document.querySelector('#m-detail').style.background = '#263176'
    }
  },
  methods: {
    // 点击回到m-home页
    slideChangeFn(index) {
      this.$router.push({name: 'home', query: {index}})
    },
    closeList() {
      this.showList = false;
      if (this.$refs.mhead) {
        this.$refs.mhead.closeListFn();
      }
    },

  }
};
</script>

<style lang="scss">
@import "@/assets/scss/views/mobile/m-detail.scss";
</style>
